import './review_images.js';
import { initPageCarousels } from '../functions/carousel.js';
import { initHeader } from './header.js';
import { initFooter } from './footer.js';
import { initProductListTabs } from './product_list_tabs.js';
import { initScrollbar } from './scrollbar.js';
import { initSearchCarousel } from './search_carousel.js';

let initialized = false;

function initCarousels() {
    const hasCarousels = document.querySelector(
        '[data-swiper]:not([data-swiper="false"])'
    );

    if (!hasCarousels) {
        return;
    }

    initPageCarousels();
}

function initComponent(name, initializer) {
    try {
        initializer();
    } catch (error) {
        console.error(`Erro ao inicializar ${name}:`, error);
    }
}

/**
 * Inicializa os componentes compartilhados por todas as páginas starter.
 */
export function initGlobalComponents() {
    if (initialized) {
        return;
    }

    initialized = true;

    initComponent('cabeçalho', initHeader);
    initComponent('carrossel da busca', initSearchCarousel);
    initComponent('carrosséis', initCarousels);
    initComponent('listas de produtos em abas', initProductListTabs);
    initComponent('rodapé', initFooter);
    initComponent('ScrollBar', initScrollbar);
}
